/* Day separators (card 4ynbWszGdqUd): the stream is newest-at-top, so a
   separator labels the day of the messages BELOW it. It is inserted whenever a
   message's calendar day differs from the message above it. Keys are local
   YYYY-MM-DD so a couple in the same timezone sees the same groupings. */
export function dayKey(ts?: number): string | null {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return null;
  const d = new Date(ts);
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}
export function dayLabel(ts?: number): string {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return '';
  const d = new Date(ts);
  const today = new Date();
  const yest = new Date(today.getTime() - 86_400_000);
  const same = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  if (same(d, today)) return 'Today';
  if (same(d, yest)) return 'Yesterday';
  return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
}
